'use client'
import React, {createContext, ReactNode, useContext, useReducer, useEffect} from "react";
import {BaseInfo, UserGlobalInfo} from "@/Core/Login/types/user";
import UserMgr from "@/Core/UserMgr";
import { Provider } from "react-redux";
import { store } from "@/app/store";

export const UserContext = createContext<UserGlobalInfo | null>(null);
export const UserDispatchContext = createContext<React.Dispatch<any> | null>(null);

export function UserProvider({children}: { children: ReactNode }) {
    const [user, dispatch] = useReducer<React.Reducer<UserGlobalInfo, any>>(
        UserMgr.userReducerUpdate,
        UserMgr.defaultUserInfo
    )

    return (
        <Provider store={store}>
            <UserContext.Provider value={user}>
                <UserDispatchContext.Provider value={dispatch}>
                    {children}
                </UserDispatchContext.Provider>
            </UserContext.Provider>
        </Provider>
    )
}

//获取使用用户所有信息
export function useUser(): UserGlobalInfo {
    let context = useContext(UserContext);
    if (!context) {
        return UserMgr.defaultUserInfo;
    }
    return context;
}

export function useUserBaseInfo(): BaseInfo {
    return useUser().baseInfo;
}

export function useUserDispatch() {
    return useContext(UserDispatchContext);
}

